import { render, staticRenderFns } from "./hotmore.vue?vue&type=template&id=4b17929b&scoped=true"
import script from "./hotmore.vue?vue&type=script&lang=js"
export * from "./hotmore.vue?vue&type=script&lang=js"
import style0 from "./hotmore.vue?vue&type=style&index=0&id=4b17929b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b17929b",
  null
  
)

export default component.exports